import { render } from "./NotFound.vue?vue&type=template&id=b04cadca&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=b04cadca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b04cadca"

export default script